import BaseEvent from './BaseEvent.js';

class TerminateMeetingEvent extends BaseEvent {
  handle() {
    this.context._api.terminateMeeting();
  }
}

export default TerminateMeetingEvent;
